var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({'background-image':'url(' + _vm.background.image + ')'}),attrs:{"id":"bg-image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }